import React, { useState } from 'react';
import Image from 'next/image';
import VideoCardsSlider from '../MediaLibrary/VideoCardsSlider';
import type { Video } from '@/types/video';

interface MainVideoCardProps {
  imageSrc?: string;
  imageAlt?: string;
  videos?: Video[];
  author: string;
  languages?: string;
  cardAlwayVisible?: boolean;
}

const MainVideoCard: React.FC<MainVideoCardProps> = ({
  imageSrc,
  imageAlt,
  videos,
  author,
  languages,
  cardAlwayVisible,
}) => {
  const [hoveredVideo, setHoveredVideo] = useState<string | null>(null);

  const currentImageSrc = hoveredVideo || imageSrc;

  return (
    <div className="relative rounded-2xl flex">
      <div className="w-full relative pb-[56.25%]">
        {' '}
        {/* 16:9 aspect ratio */}
        {currentImageSrc && (
          <Image
            src={currentImageSrc}
            alt={imageAlt || 'Video thumbnail'}
            fill
            className="absolute inset-0 w-full h-full object-cover rounded-2xl"
          />
        )}
      </div>
      <div className="absolute bottom-0 left-0 z-10 p-4 w-full">
        <VideoCardsSlider
          videos={videos as Video[]}
          author={author}
          languages={languages}
          onHover={(imageUrl) => setHoveredVideo(imageUrl)}
          cardAlwayVisible={cardAlwayVisible}
          isInsideLink={true}
        />
      </div>
    </div>
  );
};

export default MainVideoCard;
